var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 .85a2.15 2.15 0 0 1 2.145 1.996L20.15 3v9a2.15 2.15 0 0 1-1.996 2.145L18 14.15H3a2.15 2.15 0 0 1-2.145-1.996L.85 12V3A2.15 2.15 0 0 1 2.846.855L3 .85h15zm0 1.5H3a.65.65 0 0 0-.643.554L2.35 3v9c0 .326.24.597.554.643L3 12.65h15a.65.65 0 0 0 .643-.554L18.65 12V3a.65.65 0 0 0-.65-.65zm-7.829 2.97.386.16.203.09.42.192.427.205.425.214.411.216.197.108.369.21c.583.344.991.644.991.786 0 .157-.494.503-1.171.888l-.386.213-.41.216-.426.213-.428.205-.419.191-.4.173c-.129.054-.252.103-.369.148l-.327.12c-.403.136-.664.179-.664.072V5.063c0-.151.494-.016 1.171.257z"
  })));
};

export default SvgPlay;